import React from "react";
import ReactTable from "react-table";
import NoData from "../page/NoData";
import { connect } from "react-redux";
import Pagination from '../page/Pagination';
import { TableConfig } from "../../utils/appConfig";

const NoDataComponent = props => (
    <NoData
        noDataText="transactionReports_NoData"
        {...props}
    />
);

const DynamicReportsView = (props) => {

    const getColumns = () => {
        const columnData = props.reportsData?.columnNames;

        if (!columnData) {
            return [];
        }
        return columnData.map(item => {
            return {
                Header: () => item,
                accessor: item
            }
        });
    }
    const onPageChange = (data) => props.onPageChange?.(data);
    const onPageSizeChange = (data) => props.onPageSizeChange?.(data);

    return (
        <div data-testid="dynamic-reports-view">
            {props.reportsData &&
                <ReactTable
                    manual
                    minRows={0}
                    maxRows={0}
                    data={props.reportsData?.data || []}
                    columns={(props.reportsData?.data && getColumns()) || []}
                    loading={props.loading}
                    NoDataComponent={NoDataComponent}
                    defaultPageSize={TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE}
                    pages={Math.ceil(props.reportsData?.totalCount / props.paginationData?.pageSize)}
                    PaginationComponent={Pagination}
                    showPagination={true}
                    sortable={false}
                    onPageSizeChange={onPageSizeChange}
                    onPageChange={onPageChange}
                    page={props.paginationData.page - 1}
                />
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        reportsData: state.dynamicReports?.reportsData,
        error: state.dynamicReports?.error,
        loading: state.dynamicReports?.loading
    }
}

export default connect(mapStateToProps, null)(DynamicReportsView);
